import styled from '@emotion/styled';
import { FC } from 'react';
import { IconReview32 } from 'components/base/Icon';
import Link from 'components/base/Link';
import Text from 'components/base/Text';
import { gray300, gray_active } from 'styles/colors';
import { typography } from 'styles/font';

interface Props {
  title: string;
  text: string;
  button_title?: string;
  button_link?: string;
}

/**
 * 작성된 리뷰가 없는 경우 사용되는 컴포넌트
 * 사용처: 마이페이지 리뷰, PDP 리뷰
 * @component
 */
const EmptyReview: FC<Props> = ({ title, text, button_title, button_link }) => {
  return (
    <SC.Container>
      <IconReview32 width={60} height={60} color={gray300} />
      <Text variant='title5_bold' className='title'>
        {title}
      </Text>
      <Text variant='body3' color='gray700' className='text' mb={24}>
        {text}
      </Text>
      {button_title && button_link && (
        <Link href={button_link}>
          <div className='link_button'>{button_title}</div>
        </Link>
      )}
    </SC.Container>
  );
};

export default EmptyReview;

const SC = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 80px;

    .title {
      margin: 12px 0 10px;
    }
    .text {
      white-space: pre-wrap;
      text-align: center;
    }
    .link_button {
      border-radius: 4px;
      border: 1px solid ${gray300};
      padding: 11px 16px 10px;
      color: ${gray_active};
      ${typography.title5_medium};
    }
  `,
};
